export { default } from "./testInformationCard";
